(function () {
    'use strict';

    angular.module('app.tenants', [
        'app.core',
        'app.widgets'
    ]);
})();
